<div *ngIf="!addingSeparator" class="contextmenu" [ngStyle]="{ 'left.px': positionX, 'top.px': positionY }" data-cy="note-builder-context-menu">
  <div matTooltip="Disabled until action has completed" matTooltipDisabled="{{ !actionsDisabled }}" data-cy="note-builder-context-add-container">
    <button mat-button color="primary"
            [disabled]="actionsDisabled" class="context-button" (click)="emitAddNew()" data-cy="note-builder-context-add-button">
      Add new
    </button>
  </div>
  <div matTooltip="Disabled until action has completed" *ngIf="allowEditOptions" matTooltipDisabled="{{ !actionsDisabled }}" data-cy="note-builder-context-edit-container">
    <button mat-button color="primary"
            [disabled]="actionsDisabled" class="context-button" (click)="emitEdit()" data-cy="note-builder-context-edit-button">
      Edit
    </button>
  </div>
  <div matTooltip="Disabled until saving is completed" *ngIf="allowEditOptions" matTooltipDisabled="{{ !actionsDisabled }}" data-cy="note-builder-context-delete-container">
    <button mat-button color="primary"
            (click)="emitDelete()"
            [disabled]="actionsDisabled" class="context-button" data-cy="note-builder-context-delete-button">
      Delete
    </button>
  </div>
  <div matTooltip="Disabled until saving is completed" *ngIf="allowEditOptions" matTooltipDisabled="{{ !actionsDisabled }}" data-cy="note-builder-context-separator-container">
    <button mat-button color="primary"
            (click)="addingSeparator = true"
            [disabled]="actionsDisabled" class="context-button" data-cy="note-builder-context-separator-button">
      Add Separator
    </button>
  </div>
</div>

<div *ngIf="addingSeparator" class="contextmenu" [ngStyle]="{ 'left.px': positionX, 'top.px': positionY }" data-cy="note-builder-separator-menu">
  <mat-form-field class="w-100 mb-2" data-cy="note-builder-separator-field">
    <input matInput [value]="separatorHeader"
           (input)="separatorHeader = $event.target.value"
           placeholder="Header"
           [formControl]="headerFormControl"
           [errorStateMatcher]="matcher" 
           data-cy="note-builder-separator-input" />

    <mat-error *ngIf="headerFormControl.hasError('required')" data-cy="note-builder-separator-error">
      Header is required
    </mat-error>
  </mat-form-field>

  <button class="btn btn-primary btn-sm w-100" (click)="emitAddSeperator()" data-cy="note-builder-separator-add-button">
    Add
  </button>
</div>
